export var TroubleshootingAndOtherPOSIA = function TroubleshootingAndOtherPOSIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return COMMON_QUESTIONS_RELATED_TO_POS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [CHECK_OUT_COMMON_QUESTIONS(strictLocalize)];
    }
  };
};
var COMMON_QUESTIONS_RELATED_TO_POS = function COMMON_QUESTIONS_RELATED_TO_POS(strictLocalize) {
  return strictLocalize({
    id: "AstyzH",
    defaultMessage: [{
      "type": 0,
      "value": "Questions fréquentes relatives au TPV"
    }]
  });
};
var CHECK_OUT_COMMON_QUESTIONS = function CHECK_OUT_COMMON_QUESTIONS(strictLocalize) {
  return strictLocalize({
    id: "0Y1iv5",
    defaultMessage: [{
      "type": 0,
      "value": "Consultez les questions fréquentes relatives à l'intégration du TPV sur Faire en cliquant sur le lien de l'article. Si vous avez d'autres questions, n'hésitez pas à nous contacter."
    }]
  });
};